module.exports = "<div class=\"nx-accordion\">\n  <ng-content></ng-content>\n</div>"